<template>
  <div class="content">
  </div>
</template>
<script>
export default {
  name: "cardPrintAdd",
  data() {
    return {};
  },
  methods: {
  }
};
</script>
